import { ETD_HIDDEN_STAGE_KEYS } from "constants/clientProgressStageKeys";

export const getIsEtdHidden = (stageKey?: string | null): boolean =>
  ETD_HIDDEN_STAGE_KEYS.includes(stageKey ?? "");
